import { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import "./customer.css"

export function Customer() {
    const { id } = useParams()

    const [user, setUser] = useState(null)
    
    useEffect(() => {
        async function fetchUser() {
            const response = await fetch(`http://localhost:3001/api/users/${id}`)
            //const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/users/${id}`)
            const json = await response.json()

            if(response.ok) {
                setUser(json.user)
                console.log(json)
            }
        }

        fetchUser()
    }, [])

    return user && (
        <div className="customer">
            <div className="d-flex flex-column gap-3 cntr my-5">
                {
                    user.profilePicture ?
                        <div className="profile-picture">
                            <img
                                src={user.profilePicture}
                                width={170}
                                height={170}
                                className="rounded-circle border border-5"
                                alt=""
                            />
                        </div>
                        :
                        ""
                }

                <div className="mt-4">
                    <h1>{user.firstName + " " + user.lastName}</h1>
                </div>
                <hr />

            </div>

            <div className="d-flex user-details mt-3 md-row">
                <div className="">
                    <div>First Name</div>
                    <h3>{user.firstName}</h3>
                </div>
                <div className="lastname-adress">
                    <div>Last Name</div>
                    <h3>{user.lastName}</h3>
                </div>
            </div>

            <div className="d-flex user-details my-4 md-row">
                <div>
                    <div>Email</div>
                    <h3>{user.email}</h3>
                </div>
                <div className="lastname-adress">
                    <div>Address</div>
                    <h3>{user.address}</h3>
                </div>

            </div>

            <div className="d-flex user-details mt-4 mb-5">
                <div className="">
                    <div>Phone</div>
                    <h3>{user.phone}</h3>
                </div>
                <div className="border d-none">
                </div>
            </div>
        </div>
    )
}